import React from 'react'
import { Container, Row, Col, Input } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { Line } from 'react-chartjs-2';


class CustomerRevenueAndHourlyRate extends React.Component {

    constructor(props) {
        super(props);

        const valObj = this.getValues(this.props.width);

        this.state = {
            clientId: (this.props.widget != null && this.props.widget.userConfiguration != null && this.props.widget.userConfiguration.clientId != null &&
                this.props.widget.userConfiguration.clientId > 0) ? this.props.widget.userConfiguration.clientId : 0,
            data: [],
            labels: [],
            col1: valObj.col1,
            col2: valObj.col2,
            graphHeight: valObj.graphHeight
        };

        this.graphStyles = {
            fill: false,
            lineTension: 0.1,
            borderCapStyle: 'butt',
            borderJoinStyle: 'miter',
            pointBorderWidth: 1,
            pointRadius: 2,
            pointHoverRadius: 5,
            pointHitRadius: 10,
        };
        this.colors = ['#005c1e', '#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600'];
        this.options = {
            maintainAspectRatio: false,
            responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        userCallback: function (value, index, values) {
                            value = value.toString();
                            value = value.split(/(?=(?:...)*$)/);
                            value = value.join(',');
                            return '$' + value;
                        }
                    }
                }]
            },
        }
    }

    getValues = (width) => {
        this.props.info('CustomerRevenueAndHourlyRate.js/getValues');
        let col1 = 0, col2 = 0, graphHeight = 0;
        switch (width) {
            case 4:
                col1 = 12; col2 = 12; graphHeight = 250;
                break;
            case 6:
                col1 = 12; col2 = 12; graphHeight = 250;
                break;
            case 12:
                col1 = 3; col2 = 9; graphHeight = 300;
                break;
            default:
        }
        return { col1: col1, col2: col2, graphHeight: graphHeight }
    }

    componentDidMount() {
        this.props.log('CustomerRevenueAndHourlyRate.js/componentDidMount');
        if (this.state.clientId > 0) this.onSubmit();
        this.props.callback((width) => {
            const CBvalObj = this.getValues(width);
            this.setState({
                graphHeight: CBvalObj.graphHeight,
                col1: CBvalObj.col1,
                col2: CBvalObj.col2
            })
        });
    }

    onChange = (e) => {
        this.props.log('CustomerRevenueAndHourlyRate.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.setState({
            clientId: parseInt(e.target.value)
        }, () => {
            this.props.handleChange(this.props.id, 'clientId', this.state.clientId);
            this.onSubmit();
        })
    }

    onSubmit = () => {
        this.props.log('CustomerRevenueAndHourlyRate.js/onSubmit');
        fetch('/api/widgets-data/CustomerRevenueHourlyRateOverTime', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'clientId', type: 'int', value: this.state.clientId }
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.createGraphData(results.data)
                } else {
                    this.props.addToast('Unable to download customer revenue and hourly rate data.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    createGraphData = (arr) => {
        this.props.log('CustomerRevenueAndHourlyRate.js/createGraphData (arr)', arr);
        let labels = [];
        let data = {
            'Hourly Rate': {
                ...this.graphStyles,
                label: 'Hourly Rate',
                borderColor: this.colors[0],
                pointBorderColor: this.colors[0],
                data: []
            },
            'Total': {
                ...this.graphStyles,
                label: 'Total',
                borderColor: this.colors[1],
                pointBorderColor: this.colors[1],
                data: []
            },
        };
        arr.forEach(row => {
            data['Hourly Rate'].data.push(row['hourlyDollars'] !== null ? row['hourlyDollars'] : 0);
            data['Total'].data.push(row['total'] !== null ? row['total'] : 0);
            labels.push(row['month'] + '/' + row['year']);
        });
        this.setState({
            data: data,
            labels: labels
        })
    }

    render() {
        this.props.info('CustomerRevenueAndHourlyRate.js/render');
        return (<Container fluid={true}>
            <Row className="mb-4">
                <Col md={this.state.col1} className="px-1 noPrint text-left">
                    <Input type="select" className="" name="clientId" value={this.props.isFieldNull(this.state.clientId)} onChange={(e) => this.onChange(e)}>
                        <option value="0">Select Company</option>
                        {this.props.clients.filter(client => client.active).map(client => (
                            <option key={client.id} value={this.props.isFieldNull(client.id)}>{client.client}</option>
                        ))}
                    </Input>
                </Col>
                <Col md={this.state.col2}>
                    {this.state.labels.length > 0 ?
                        <div style={{ height: this.state.graphHeight + 'px' }}>
                            <Line data={{
                                labels: this.state.labels,
                                datasets: [
                                    this.state.data['Hourly Rate'],
                                    this.state.data['Total'],
                                ]
                            }} options={this.options} />
                        </div>
                        : <>No data available</>}
                </Col>
            </Row>
        </Container>
        );
    }
}

export default CustomerRevenueAndHourlyRate;